export default {
      id: "flex-justifyContent-flex-start-usage",
      viewBox: "0 0 40 40",
      url: "assets/" + "sprite.svg#flex-justifyContent-flex-start-usage",
      toString: function () {
        return this.url;
      }
    }